module.exports = __webpack_public_path__ + "img/link_chain_on.5ea9c81d.svg";